<template src="@/components/AppHeader.html" />
<style lang="scss" scoped src="@/components/AppHeader.scss" />
<script>
import {
  SfButton,
  SfIcon,
  SfImage,
  SfMegaMenu,
  SfOverlay,
  SfBadge,
  SfLoader,
  SfLink
} from '@storefront-ui/vue';
import {OrkLoader} from "@/components/Ork";
import AppHeaderDesktopNavigation from '@/components/AppHeaderDesktopNavigation';
import SearchResults from '@/components/SearchResults';
import SearchBar from '@/components/SearchBar';
import {icons} from "@/utils/icons";
import {clickOutside} from '@storefront-ui/vue/src/utilities/directives/click-outside/click-outside-directive.js';
import { configuration } from "@/config/InstanceConfiguration";

export default {
  name: 'AppHeader',
  components: {
    SfLink,
    OrkLoader,
    SfButton,
    SfImage,
    SfIcon,
    SfMegaMenu,
    SfBadge,
    SfLoader,
    SfOverlay,
    SearchResults,
    SearchBar,
    AppHeaderDesktopNavigation
  },
  data() {
    return {
      icons: icons,
      currentRoute: null,
      accountIcon: 'profile',
      cartTotalItems: 0,
    };
  },
  directives: {clickOutside},
  computed: {
    categoryTree: function() { return this.$store.getters.getCategoryTree; },
    rootCategoryName() { return this.$store.getters.getRootCategoryLabel },
    user: function() { return this.$store.getters.getProfile; },
    isAuthenticated: function() { return this.$store.getters.isAuthenticated; },
    cart: function() { return this.$store.getters.getCart; },
    isCustomerActive: function() { return this.$route.name === 'My-account'; },
    showCart: () => configuration.header.icons.showCart,
    showQuickOrder: () => configuration.header.icons.showQuickOrder,
    showBecomeSeller: () => configuration.header.icons.showBecomeSeller,
    showContact: () => configuration.header.icons.showContact,
    showAccount: () => configuration.header.icons.showAccount,
    showRootCategorySelection() { return configuration.header.icons.showRootCategory }
  },
  mounted() {
    this.$store.dispatch('getMe');
  },
  methods: {
    openRootCategoryModal() {
      this.$store.dispatch('openRootCategoryModal')
    },
    handleAccountClick() {
      if (this.isAuthenticated) {
        return this.$router.push({name: "My-account"});
      } else {
        this.$store.dispatch('toggleLoginModal', {open: true})
      }
    },
    toggleCartSidebar() {
      this.$store.dispatch('toggleCartSidebar')
    },
    toggleQuickOrder() {
      this.$store.dispatch('toggleQuickOrder', {open: true})
    },
    // removeSearchResults() {
    //   this.searchTerms = [];
    //   this.searchResult = {content: [], totalItems: 0, loading: false}
    // },
    // closeSearch() {
    //   //  this.searchTerm = '';
    //   this.searchTerms = [];
    //   this.searchResult = {content: [], totalItems: 0, loading: false}
    //   this.$store.dispatch('closeSearch')
    // },
    // toggleSearch() {
    //   this.$store.dispatch('toggleSearch')
    // },
    // openSearch() {
    //   this.$store.dispatch('openSearch')
    // }
  }
};
</script>